<script setup lang="ts">
import {computed} from "vue";
import {useRoute, useRouter} from "vue-router";
import {Tabs, TabsContent, TabsList, TabsTrigger} from "@/core/components/ui/tabs";
import CommunicationConversationMessagesHistory
    from "@/communication/components/history/CommunicationConversationMessagesHistory.vue";
import CommunicationSMSHistory from "@/communication/components/batch-tables/sms/CommunicationSMSHistory.vue";

const MESSAGES_TAB = "messages";
const BATCHES_TAB = "batches";

const route = useRoute();
const router = useRouter();

const tab = computed(() => route.query.tab === BATCHES_TAB ? BATCHES_TAB : MESSAGES_TAB);

const handleTabChange = (value: string | number) => {
    if (value === tab.value) {
        return;
    }

    router.replace({query: {...route.query, tab: String(value)}});
};
</script>

<template>
  <div class="p-4 flex flex-col gap-4">
    <h1>Historique des envois</h1>
    <Tabs :model-value="tab" class="w-full flex flex-col gap-2" @update:model-value="handleTabChange">
      <TabsList class="self-start">
        <TabsTrigger :value="MESSAGES_TAB">
          Tous les messages
        </TabsTrigger>
        <TabsTrigger :value="BATCHES_TAB">
          Campagnes
        </TabsTrigger>
      </TabsList>
      <TabsContent :value="MESSAGES_TAB">
        <CommunicationConversationMessagesHistory />
      </TabsContent>
      <TabsContent :value="BATCHES_TAB">
        <CommunicationSMSHistory />
      </TabsContent>
    </Tabs>
  </div>
</template>
